import D2C_ServiceData from './Data'

class D2C_ServicePostgres extends D2C_ServiceData {
  static objectType = 'serviceType'
  static active = true
  static order = 22
  static typeName = 'postgres'
  static typeTitle = 'Postgres'
  static color = '#006699'
  static methods = {
    ...D2C_ServiceData.methods,
    backupDatabase: true,
    resetPassword: true,
    scale: true,
  }
  static fields = {
    ...D2C_ServiceData.fields,
    configs: {
      ...D2C_ServiceData.fields.configs,
      default: [
        {name: 'main.conf', text: require('raw-loader!@/assets/configs/postgres-main.conf').default, custom: false},
      ],
    },
    configuration: {
      default: 'StandAlone',
      enum: [
        {value: 'StandAlone', text: 'StandAlone'},
        {value: 'MasterSlave', text: 'MasterSlave'},
      ],
      label: 'Configuration',
      path: 'configuration',
      required: false,
      validate() {
        return null
      },
      creating: {},
      migrating: {
        readonly: true,
        required: true,
      },
      importing: {},
    },
    database: {
      default: '',
      label: 'Create database',
      tooltip: '`postgress` database will be created anyway',
      path: 'database',
      required: false,
      validate(value) {
        if (value && value.length > 63) {
          return 'Maximum length is 63 symbols'
        }
        return null
      },
      creating: {},
      importing: {},
    },
    hosts: {
      ...D2C_ServiceData.fields.hosts,
      selector: {
        StandAlone: ['master'],
        MasterSlave: ['master', 'slave'],
      },
      validate(value, entity) {
        if (entity.configuration === 'MasterSlave') {
          const masters = entity.hosts.filter(host => host.role === 'master')
          const slaves = entity.hosts.filter(host => host.role === 'slave')
          if (!masters.length && !entity.created) {
            return 'Master host is not selected'
          }
          if (!slaves.length) {
            return 'Must be selected at least one slave'
          }
          if (value.length > 20) {
            return 'Available only 20 selected hosts'
          }
        }
        return (value && value.length > 0) ? null : 'Must be selected at least one host'
      },
    },
    image: {
      ...D2C_ServiceData.fields.image,
      default: 'postgres',
    },
    ports: {
      ...D2C_ServiceData.fields.ports,
      default: [
        {protocol: 'TCP', value: 5432},
      ],
    },
    username: {
      default: 'postgres',
      label: 'Superuser login',
      path: 'username',
      required: false,
      width: 7,
      validate(value, entity) {
        if (value && value.length > 63) {
          return 'Maximum length is 63 symbols'
        }
        if (!value && entity.userPassword) {
          return 'Username is not set'
        }
        return null
      },
      creating: {},
      importing: {},
      resetingPassword: {
        readonly: true,
      },
    },
    userPassword: {
      default: '',
      label: 'Superuser password',
      path: 'userPassword',
      required: true,
      width: 9,
      validate(value) {
        if (value ? value.length < 6 : this.required) {
          return 'Minimum length is 6 symbols'
        }
        return null
      },
      creating: {},
      importing: {},
      resetingPassword: {
        autoselect: true,
        label: 'New superuser password',
        required: true,
      },
    },
    version: {
      ...D2C_ServiceData.fields.version,
      default: '14',
      enum: ['9', '10', '11', '12', '13', '14'],
    },
    volumes: {
      ...D2C_ServiceData.fields.volumes,
      demo: [
        {src: '/ebs/containers/$serviceName/data', dst: '/var/lib/postgresql/data', sync: false},
        {src: '/ebs/containers/$serviceName/configs', dst: '/d2c/configs', sync: false},
      ],
    },
  }
}

export default D2C_ServicePostgres
